import type {
    IPortalAccountEmailAddress,
    IPortalAccountPhoneNumber,
    IPortalAccountPhoneNumberUpdate,
    IPortalAccount
} from '../../domain';
import { ApiBaseService } from '../api-base-service';

export const ENDPOINTS = {
    portalAccounts: 'portal-accounts',
    emailAddresses: 'email-addresses',
    phoneNumbers: 'phone-numbers',
};

export const BASE_API = `/portal-account`;
export const VERSION = `v4`;
export const BASE_URL = `/delegate${BASE_API}/${VERSION}`;

export class PortalAccountApiService extends ApiBaseService {
    constructor() {
        super(BASE_URL);
    }

    async fetchUserPortalAccount(): Promise<IPortalAccount[]> {
        return this.http
            .get<IPortalAccount[]>(`/${ENDPOINTS.portalAccounts}`, { params: { 'authorized-portal-account-only': true } })
            .then((response) => response.data);
    }

    async fetchPortalAccounts(loginId: string): Promise<IPortalAccount[]> {
        const params = {
            'login-id': loginId,
        };

        return this.http.get<IPortalAccount[]>(`/${ENDPOINTS.portalAccounts}`, { params }).then((response) => response.data);
    }

    async fetchCreatedMailFromLocation(location: string): Promise<IPortalAccountEmailAddress> {
        return this.fetchObjectFromLocation<IPortalAccountEmailAddress>(location.replace(`${BASE_API}/${VERSION}`, ''));
    }

    async fetchCreatedPhoneNumberFromLocation(location: string): Promise<IPortalAccountPhoneNumber> {
        return this.fetchObjectFromLocation<IPortalAccountPhoneNumber>(location.replace(`${BASE_API}/${VERSION}`, ''));
    }

    async createEmailAddress(emailAddress: IPortalAccountEmailAddress): Promise<string> {
        return this.http.post<IPortalAccountEmailAddress>(`/${ENDPOINTS.emailAddresses}`, emailAddress).then((response) => response.headers.location);
    }

    async deleteEmailAddress(id: string) {
        return this.http.delete(`/${ENDPOINTS.emailAddresses}/${id}`);
    }

    async createPhoneNumber(phoneNumber: IPortalAccountPhoneNumber): Promise<string> {
        return this.http.post<IPortalAccountPhoneNumber>(`/${ENDPOINTS.phoneNumbers}`, phoneNumber).then((response) => response.headers.location);
    }

    async updatePhoneNumber(phoneNumber: IPortalAccountPhoneNumber) {
        return this.http.put<IPortalAccountPhoneNumberUpdate>(`/${ENDPOINTS.phoneNumbers}/${phoneNumber.externalId}`, phoneNumber);
    }

    async deletePhoneNumber(id: string) {
        return this.http.delete(`/${ENDPOINTS.phoneNumbers}/${id}`);
    }

    private async fetchObjectFromLocation<T>(location: string): Promise<T> {
        return this.http.get<T>(location).then((response) => response.data);
    }
}
